import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography
} from "@mui/material";

function ClientCommunicatorFilterModal({
  open,
  onClose,
  onSelectTag,
  onClearFilter,
  selectedTagId,
  tags,
  accentColor,
  text
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3
        }
      }}>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          pr: 1
        }}>
        <Stack spacing={0.5}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {text?.TEXT_TAG_FILTER_TITLE}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {text?.TEXT_TAG_FILTER_SUBTITLE}
          </Typography>
        </Stack>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: accentColor || "text.secondary"
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={1.5}>
          <Stack
            direction="row"
            spacing={1}
            sx={{
              overflowX: "auto",
              overflowY: "hidden",
              flexWrap: "nowrap",
              pb: 0.5,
              "&::-webkit-scrollbar": {
                height: 6
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: accentColor || "rgba(0,0,0,0.2)",
                borderRadius: 999
              }
            }}>
            <Chip
              clickable
              label={text?.TEXT_ALL_TAGS}
              onClick={() => onSelectTag(0)}
              variant={selectedTagId === 0 ? "filled" : "outlined"}
              sx={{
                flexShrink: 0,
                borderRadius: "999px",
                borderColor: accentColor || "primary.main",
                color: selectedTagId === 0 ? "#fff" : accentColor || "primary.main",
                backgroundColor: selectedTagId === 0 ? accentColor || "primary.main" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedTagId === 0
                      ? accentColor || "primary.main"
                      : "rgba(0,0,0,0.03)"
                }
              }}
            />
            {tags?.length > 0 ? (
              tags.map((tag) => {
                const isSelected = selectedTagId === tag.value;
                return (
                  <Chip
                    key={tag.value}
                    clickable
                    label={tag.label}
                    onClick={() => onSelectTag(tag.value)}
                    variant={isSelected ? "filled" : "outlined"}
                    sx={{
                      flexShrink: 0,
                      borderRadius: "999px",
                      borderColor: accentColor || "primary.main",
                      color: isSelected ? "#fff" : accentColor || "primary.main",
                      backgroundColor: isSelected
                        ? accentColor || "primary.main"
                        : "transparent",
                      "&:hover": {
                        backgroundColor: isSelected
                          ? accentColor || "primary.main"
                          : "rgba(0,0,0,0.03)"
                      }
                    }}
                  />
                );
              })
            ) : (
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {text?.TEXT_NO_TAGS_AVAILABLE}
              </Typography>
            )}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, pt: 0 }}>
        <Button
          onClick={onClearFilter}
          sx={{
            textTransform: "none",
            color: accentColor || "primary.main"
          }}>
          {text?.TEXT_ALL_TAGS}
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            textTransform: "none",
            backgroundColor: accentColor || "primary.main",
            "&:hover": {
              backgroundColor: accentColor || "primary.main"
            }
          }}>
          {text?.TEXT_CANCEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ClientCommunicatorFilterModal;
